import { ErrorMessage } from '../ErrorMessage';

export class ClientError extends Error {
  public errorMessages: ErrorMessage[];

  constructor(message: string, errorMessages: ErrorMessage[]) {
    super(message);
    this.errorMessages = errorMessages;

    // tslint:disable-next-line max-line-length
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, ClientError.prototype);
  }
}
